import moment from 'moment';

const timeAgo = (date) => {
  const now = new Date();
  let past = new Date(date);
  const nowMoment = moment(now);
  const pastMoment = moment(past);
  let timeAgoString = pastMoment.from(nowMoment); // 2 hours ago

  if (timeAgoString === 'a few seconds ago') {
    timeAgoString = 'now';
  }
  return timeAgoString;
};

export default timeAgo;



// WEBPACK FOOTER //
// ./src/lib/helpers/GeneralHelpers/timeAgo.js